import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1eaba950"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "@/assets/sass/commponents/nlp.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./index.vue?vue&type=style&index=1&id=1eaba950&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports